goog.module('yext.location.LocationTypeUpdater');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Field = goog.require('yext.Field');
const helpers = goog.require('yext.location.helpers');
const HealthcareName = goog.require('yext.location.HealthcareName');
const notify = goog.require('yext.notify');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
const textfield = goog.require('yext.textfield');

/**
 * This class provides functionality for changing a location's type. Depending
 * on the target type, different required fields are collected
 *
 * @author MattJS (matt@yext.com)
 * @param $ctx = starting context
 * @constructor
 */
const LocationTypeUpdater = function($ctx) {
  this.$ctx = $ctx.remove().show();

  this.$fields = this.$ctx.find('.js-additional-required-fields');
  this.templatesByType = this.getTemplatesByType();

  this.heathcareName = undefined;
  this.name = undefined;
  this.field = new Field(this.$ctx);

  this.configuration = {};
  /**
   * @example configuration = {
   *  value: {string} location type value,
   *  displayValue: {string} location type display value,
   *  url?: {string} url to redirect update ajax call,
   *  successCallback?:  {function()} callback upon successful update
   */

  this.createDialog();
  this.bindSubmit();
  this.bindControls();
};
goog.exportSymbol('yext.location.LocationTypeUpdater', LocationTypeUpdater);

/**
 * Builds a map from type to html template
 *
 * @return {!Object}
 */
LocationTypeUpdater.prototype.getTemplatesByType = function() {
  var templates = {};
  this.$ctx.find('.js-update-type-template').each(function() {
    var $this = $(this);
    templates[$this.data('type')] = $this.html();
  });
  return templates;
};

/**
 * @param {string} type The target location type
 */
LocationTypeUpdater.prototype.show = function(configuration) {
  this.configuration = configuration;
  // Only show dialog if updating the location type
  if (this.configuration.updatedValue !== this.configuration.initialValue) {
    this.$ctx.dialog({
      title: yext.msg('Change Profile Type - {0}', this.configuration.updatedLabel),
    }).dialog('open');
    this.setup();
  } else {
    this.update();
  }
};

/**
 * Get fields from template & bind
 */
LocationTypeUpdater.prototype.setup = function() {
  this.$fields.empty().append(this.templatesByType[this.configuration.updatedValue]);
  var self = this;
  var $healthcareName = this.$fields.find('.js-healthcare-name-edit');
  var $name = this.$fields.find('.js-name-field');

  if ($healthcareName.length
    && this.configuration.updatedValue === 'HEALTHCARE_PROFESSIONAL') {
    this.heathcareName = new HealthcareName($healthcareName);
    $(this.heathcareName).on('updated', function() {
      self.updated();
    });
  } else if (this.configuration.updatedValue === 'HEALTHCARE_FACILITY'
    && $name.length) {
    this.name = new textfield.create($name.find('.js-text-field'));
    $(this.name).on('update.textField', function() {
      self.updated();
    });
  }

  this.$fields.find('.js-npi-input').inputchange(function() {
    self.updated();
  });

  this.updated();
};

/**
 * Triggered by fields when an update is made
 */
LocationTypeUpdater.prototype.updated = function() {
  if (this.hasRequiredFields()) {
    this.field.enableSubmit();
  } else {
    this.field.disableSubmit();
  }
};

/**
 * @return {boolean} True if all required fields are set
 */
LocationTypeUpdater.prototype.hasRequiredFields = function() {
  var hasRequiredFields = true;
  if (this.configuration.updatedValue === 'HEALTHCARE_PROFESSIONAL') {
    hasRequiredFields &= !this.isEmpty(this.$fields.find('.js-npi-input').val());
    hasRequiredFields &= !this.isEmpty(this.heathcareName.firstName.value());
    hasRequiredFields &= !this.isEmpty(this.heathcareName.lastName.value());
    hasRequiredFields &= !this.isEmpty(this.heathcareName.healthcareName.value());
  } else if (this.configuration.updatedValue === 'HEALTHCARE_FACILITY') {
    hasRequiredFields &= !this.isEmpty(this.name.value());
  }
  return hasRequiredFields;
};

/**
 * @return {boolean} True if string is empty
 */
LocationTypeUpdater.prototype.isEmpty = function(value) {
  return $.trim(value).length == 0;
};

/**
 * Create dialog
 */
LocationTypeUpdater.prototype.createDialog = function() {
  var self = this;

  this.$ctx.dialog({
    autoOpen: false,
    minWidth: '600',
    draggable: false,
    modal: true,
    close: function() {
      self.close();
    },
  });
};

/**
 * Listen for form submit and deal with response
 */
LocationTypeUpdater.prototype.bindSubmit = function() {
  var self = this;
  this.field.$form.on('beforeSubmit.field', function() {
    self.field.preventDefault();
    self.field.disableSubmit();
    self.hideError();
    self.update();
  });
};

/**
 * Helper method to serialize form data
 */
LocationTypeUpdater.prototype.getFormData = function() {
  return [{
    name: 'location.location_type',
    value: this.configuration.updatedValue,
  },
  {
    name: 'location.location_type.timestamp',
    value: this.configuration.timestamp,
  },
  {
    name: 'location.location_type.indeterminate',
    value: 'false',
  },
  {
    name: 'field',
    value: 'location.location_type',
  }];
};

/**
 * Manually make AJAX call to filter the data before it is saved
 */
LocationTypeUpdater.prototype.update = function() {
  var self = this;
  var data = this.getData();
  data = data.concat(self.getFormData());
  $.ajax({
    type: 'POST',
    data: data,
    url: this.configuration.url || '',
    success: function(response) {
      var error = response['error'];
      if (error) {
        if (yext.isString(error)) {
          self.showError(error);
        } else {
          self.showDefaultError();
        }
        self.field.enableSubmit();
      } else if (response['stale']) {
        self.showError(helpers.staleErrorMessage);
        self.field.enableSubmit();
      } else {
        self.message('typeChanged');
        if (self.configuration.successCallback) {
          self.configuration.successCallback();
        }
        self.$ctx.dialog('close');
        self.close();
        self.cleanup();
      }
    },
    error: function() {
      self.showDefaultError();
      self.field.enableSubmit();
    },
  });
};

/**
 * Actions to be taken upon successful update
 */
LocationTypeUpdater.prototype.cleanup = function() {
  this.configuration = {}; // Cleanup state
};

/**
 * Show a default error message
 */
LocationTypeUpdater.prototype.showDefaultError = function() {
  var message =
    yext.msg('There was an error when trying to update this location\'s type');
  this.showError(message);
};

/**
 * Show error message
 *
 * @param {string} message
 */
LocationTypeUpdater.prototype.showError = function(message) {
  this.$ctx.find('.js-error').html(message).show();
};

/**
 * Hide the error message element
 */
LocationTypeUpdater.prototype.hideError = function() {
  this.$ctx.find('.js-error').hide();
};

/**
 * Removes any 'field' named params so there is no collision with
 * the submission of the location type
 *
 * @return {!Array} List of name value pairs
 */
LocationTypeUpdater.prototype.getData = function() {
  var data = this.field.getData();
  for (var i = data.length - 1; i >= 0; i--) {
    if (data[i].name === 'field') {
      data.splice(i, 1);
    }
  }
  return data;
};

/**
 * Bind controls
 */
LocationTypeUpdater.prototype.bindControls = function() {
  var self = this;
  this.$ctx.find('.js-cancel').on('click', function() {
    self.$ctx.dialog('close');
    self.close();
  });
};

/**
 * Actions to be taken when the dialog is closed
 */
LocationTypeUpdater.prototype.close = function() {
  this.field.disableSubmit();
  this.heathcareName = undefined;
  this.name = undefined;
  this.hideError();
};

/**
 * @param {string} message
 */
LocationTypeUpdater.prototype.message = function(message) {
  $(this).trigger(message);
};

exports = LocationTypeUpdater;
